require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./constants"));
	else if(typeof define === 'function' && define.amd)
		define(["./constants"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./constants")) : factory(root["./constants"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__30__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[73],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getKeyName = getKeyName;
exports.isKey = isKey;

var _constants = __webpack_require__(30);

exports.keyNames = _constants.keyNames;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function getKeyName(e) {
  if (e.type === 'keydown' || e.type === 'keyup' || e.type === 'keypress') {
    var BACKSPACE = _constants.keyNames.BACKSPACE,
        TAB = _constants.keyNames.TAB,
        ENTER = _constants.keyNames.ENTER,
        ESCAPE = _constants.keyNames.ESCAPE,
        SPACE = _constants.keyNames.SPACE,
        END = _constants.keyNames.END,
        HOME = _constants.keyNames.HOME,
        LEFT = _constants.keyNames.LEFT,
        UP = _constants.keyNames.UP,
        RIGHT = _constants.keyNames.RIGHT,
        DOWN = _constants.keyNames.DOWN,
        A = _constants.keyNames.A,
        F10 = _constants.keyNames.F10,
        NOT_RECOGNIZED = _constants.keyNames.NOT_RECOGNIZED,
        SHIFT = _constants.keyNames.SHIFT;

    switch (e.keyCode || e.which // older browser does not support e.keyCode
    ) {
      case 8:
        return BACKSPACE;

      case 9:
        return TAB;

      case 13:
        return ENTER;

      case 16:
        return SHIFT;

      case 27:
        return ESCAPE;

      case 32:
        return SPACE;

      case 35:
        return END;

      case 36:
        return HOME;

      case 37:
        return LEFT;

      case 38:
        return UP;

      case 39:
        return RIGHT;

      case 40:
        return DOWN;

      case 65:
        return A;

      case 121:
        return F10;

      default:
        return NOT_RECOGNIZED;
    }
  } else {
    console.warn("this event " + e + " is not a keydown event");
  }
}

function isKey(e, keyName) {
  return getKeyName(e) === keyName;
}

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(599));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var PREFIX = 'is-';

function prefix(cls) {
  if (cls.length === 0 || cls.indexOf('-') >= 0 || cls.substr(0, 3) === 'is-') {
    return cls;
  }

  return "" + PREFIX + cls;
}
/**
 * Follows the same behavior as the normal 'classnames' library. If a classname has no hyphens then it is considered
 * a modifier and thereby prefixed with 'is-'.
 */


var _default = function _default() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _loop = function _loop(i) {
    var arg = args[i];

    if (typeof arg === 'string') {
      args[i] = prefix(arg);
    } else if (arg && typeof arg === 'object') {
      args[i] = {};
      Object.keys(arg).forEach(function (key) {
        return args[i][prefix(key)] = arg[key];
      });
    }
  };

  for (var i = 0; i < args.length; i++) {
    _loop(i);
  }

  return _classnames["default"].apply(void 0, args);
};

exports["default"] = _default;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _createClass2 = _interopRequireDefault(__webpack_require__(131));

var _react = _interopRequireDefault(__webpack_require__(1));

var _lodash = __webpack_require__(34);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/**
 *   Utils which allow to control bidi-specific features: btd, stt, numeric shaping
 */
var DEFAULT_DIR = '';
var DEFAULT_BTD = '';
var DEFAULT_G11N = 'default';
var LTR = 'ltr';
var RTL = 'rtl';
var CONTEXTUAL = 'contextual';
var AUTO = 'auto';
var EUROPIAN = 0;
var INDIC = 1;
var LRE = "\u202A";
var RLE = "\u202B";
var PDF = "\u202C";
var LRM = "\u200E";
var RLM = "\u200F";
var REG_DIR = /[A-Za-z\u05d0-\u065f\u066a-\u06ef\u06fa-\u07ff\ufb1d-\ufdff\ufe70-\ufefc]/;
var REG_SH = /([0-9])|([\u0660-\u0669])|([\u0590-\u05FF\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE]+)|([^0-9\u0590-\u05FF\u0660-\u0669\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FF\u0750-\u077F\u08A0-\u08E3\u200F\u202B\u202E\u2067\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFC\uFDFE-\uFDFF\uFE70-\uFEFE\u0600-\u0607\u0609-\u060A\u060C\u060E-\u061A\u064B-\u066C\u0670\u06D6-\u06E4\u06E7-\u06ED\u06F0-\u06F9\u08E4-\u08FF\uFD3E-\uFD3F\uFDD0-\uFDEF\uFDFD\uFEFF\u0000-\u0040\u005B-\u0060\u007B-\u007F\u0080-\u00A9\u00AB-\u00B4\u00B6-\u00B9\u00BB-\u00BF\u00D7\u00F7\u02B9-\u02BA\u02C2-\u02CF\u02D2-\u02DF\u02E5-\u02ED\u02EF-\u02FF\u2070\u2074-\u207E\u2080-\u208E\u2100-\u2101\u2103-\u2106\u2108-\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A-\u213B\u2140-\u2144\u214A-\u214D\u2150-\u215F\u2189\uA720-\uA721\uA788\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE]+)/g;
var computedDirection = window.getComputedStyle && window.getComputedStyle(document.documentElement).direction;

function hasArabicChar(text, after) {
  if (!text) {
    return false;
  }

  var result = '';

  if (after) {
    var ind = text.indexOf(after);

    if (ind > 0 && ind < text.length - 1) {
      result = text.substring(ind + 1);
    }
  }

  var fdc = /[\u0600-\u065f\u066a-\u06ef\u06fa-\u07ff\ufb1d-\ufdff\ufe70-\ufefc]/.exec(result);
  return !!fdc;
}

var TextSegment = function TextSegment(text, flowDir, segDir, isSeparator) {
  if (isSeparator === void 0) {
    isSeparator = false;
  }

  this.text = text;
  var guiDir = Bidi.isMirroredUI() ? RTL : LTR;
  this.flowDir = flowDir === DEFAULT_DIR ? guiDir : flowDir;
  this.segDir = segDir === DEFAULT_DIR ? this.flowDir : segDir;
  this.isSeparator = isSeparator;
};

var Bidi = /*#__PURE__*/function () {
  function Bidi() {
    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    this._props = props;
  }

  Bidi.getTextDir = function getTextDir(btd) {
    var _btd = btd || Bidi._getTextDir();

    if (!Bidi.isBidi() || _btd === DEFAULT_BTD || _btd === DEFAULT_G11N) {
      return DEFAULT_BTD;
    } else if (_btd !== CONTEXTUAL && _btd !== AUTO) {
      return _btd;
    }

    return AUTO;
  };

  Bidi.getDir = function getDir(dir) {
    var _dir = dir || Bidi._getDir();

    if (!Bidi.isBidi() || _dir === DEFAULT_DIR || _dir === DEFAULT_G11N) {
      return DEFAULT_DIR;
    } else if (_dir !== CONTEXTUAL && _dir !== AUTO) {
      return _dir;
    }

    return AUTO;
  };

  Bidi.resolveDir = function resolveDir(txt, dir) {
    var text = txt;

    if (typeof text === 'number') {
      text = "" + text;
    }

    var _dir = dir || Bidi.getDir();

    if (text === null || text === undefined || !Bidi.isBidi() || dir === DEFAULT_DIR || dir === DEFAULT_G11N) {
      return DEFAULT_DIR;
    } else if (dir !== CONTEXTUAL && dir !== AUTO) {
      return dir;
    }

    var fdc = REG_DIR.exec(text);

    if (fdc) {
      return fdc[0] <= 'z' ? LTR : RTL;
    }

    return Bidi.isMirroredUI() ? RTL : LTR;
  };

  Bidi.resolveTextDir = function resolveTextDir(txt, pageTextDir, textDir) {
    var text = txt;

    if (typeof text === 'number') {
      text = "" + text;
    }

    var btd = textDir || pageTextDir || Bidi.getTextDir();

    if (text === null || text === undefined || !Bidi.isBidi() || btd === DEFAULT_DIR || btd === DEFAULT_G11N) {
      return DEFAULT_DIR;
    } else if (btd !== CONTEXTUAL && btd !== AUTO) {
      return btd;
    }

    var fdc = REG_DIR.exec(text);

    if (fdc) {
      return fdc[0] <= 'z' ? LTR : RTL;
    }

    return Bidi.isMirroredUI() ? AUTO : LTR;
  };

  Bidi.resolveNumShape = function resolveNumShape(pageNumShape, numShape) {
    var ns = numShape || pageNumShape || Bidi.getNumShape();

    if (typeof ns === 'string') {
      return String(ns) === 'true';
    }

    return ns;
  };

  Bidi.enforceDir = function enforceDir(txt, outType, dir, reshape, startKey) {
    if (reshape === void 0) {
      reshape = false;
    }

    if (startKey === void 0) {
      startKey = 0;
    }

    var text = txt;

    if (typeof text === 'number') {
      text = "" + text;
    }

    var btd = Bidi.resolveDir(text, dir);

    if (!Bidi.isBidi() || !text || btd === DEFAULT_DIR) {
      return Bidi.reshape(text, reshape);
    } else if (outType === Bidi.AS_STRING) {
      return (btd === RTL ? RLE : LRE) + Bidi.reshape(text, reshape) + PDF;
    } else if (outType === Bidi.AS_HTML) {
      return "<bdi dir='" + btd + "'>" + Bidi.reshape(text, reshape) + "</bdi>";
    }

    return /*#__PURE__*/_react["default"].createElement("bdi", {
      key: "" + startKey,
      dir: btd
    }, Bidi.reshape(text, reshape));
  };

  Bidi.reshape = function reshape(txt, needReshape, needUnshape) {
    if (needReshape === void 0) {
      needReshape = true;
    }

    if (needUnshape === void 0) {
      needUnshape = false;
    }

    var text = txt;

    if (typeof text === 'number') {
      text = "" + text;
    }

    if (!text || !Bidi.isBidi() && !needUnshape || !needReshape && !needUnshape) {
      return text;
    }

    var userLang = Bidi.getUserLanguage();
    var browserLang = window.navigator.languages ? window.navigator.languages[0] : window.navigator.language || window.navigator.userLanguage;
    var nsType = userLang.substring(0, 2).toLowerCase() === 'ar' ? INDIC : EUROPIAN;
    var country = '';

    if (userLang.length > 2) {
      country = userLang.substring(3);
    } else if (browserLang.length > 2) {
      country = browserLang.substring(3);
    }

    var useLatin = ['DZ', 'EH', 'LY', 'MA', 'TN'].some(function (item) {
      return item === country.toUpperCase();
    });

    if (useLatin) {
      nsType = EUROPIAN;
    }

    if (needUnshape) {
      nsType = EUROPIAN;
    }

    var result = text.replace(REG_SH, function (curChs, latNum, araNum) {
      if (araNum) {
        if (nsType === EUROPIAN) {
          return araNum.charCodeAt(0) - 1632;
        }

        return araNum;
      } else if (latNum) {
        if (nsType === INDIC) {
          return String.fromCharCode(parseInt(latNum, 10) + 1632);
        }

        return latNum;
      }

      return curChs;
    });
    return result;
  };

  Bidi.isolate = function isolate(text, outType, dir, startKey) {
    if (startKey === void 0) {
      startKey = 0;
    }

    var outDir = Bidi.isMirroredUI() ? RTL : LTR;
    var guiDir = dir || outDir;

    if (!text || !Bidi.isBidi()) {
      return text;
    } else if (outType === Bidi.AS_STRING) {
      var mark = guiDir === RTL ? RLM : LRM;
      return mark + text + mark;
    } else if (outType === Bidi.AS_HTML) {
      return "<span style=\"direction: " + guiDir + "; unicode-bidi: embed;\"></span>" + text + "<span style=\"direction: " + guiDir + "; unicode-bidi: embed;\"></span>";
    }

    var spStyle = {
      direction: guiDir,
      unicodeBidi: 'embed'
    };
    var result = [];
    result.push( /*#__PURE__*/_react["default"].createElement("span", {
      key: startKey * 100 + 1,
      style: spStyle
    }));
    result.push( /*#__PURE__*/_react["default"].createElement("span", {
      key: startKey * 100 + 2
    }, text));
    result.push( /*#__PURE__*/_react["default"].createElement("span", {
      key: startKey * 100 + 3,
      style: spStyle
    }));
    return result;
  };

  Bidi.parse = function parse(text, sttType, delimiters, flowDir, segDir, findFromEnd, stopIn) {
    var results = [new TextSegment(text, flowDir, segDir)];
    var dels = (0, _lodash.isString)(delimiters) ? delimiters.split('') : delimiters;
    var count = 0;
    var ind = 0;
    var offset = 0;
    var curDel = '';
    var point = '';

    while (true) {
      var actInd = findFromEnd ? results.length - ind - 1 : ind;

      if (results[actInd].isSeparator) {
        ind++;

        if (ind === results.length) {
          break;
        } else {
          continue;
        }
      }

      var curText = results[actInd].text;
      curDel = '';
      offset = findFromEnd ? -1 : curText.length;
      var found = false;
      var i = 0;

      for (i = 0; i < dels.length; i++) {
        point = dels[i];
        var delOffset = findFromEnd ? curText.lastIndexOf(point) : curText.indexOf(point);

        if (delOffset < 0) {
          continue;
        } else if (findFromEnd && delOffset > offset || !findFromEnd && delOffset < offset) {
          offset = delOffset;
          curDel = point;
          found = true;
        }
      }

      if (found) {
        results.splice(actInd + 1, 0, new TextSegment(curDel, flowDir, flowDir, true));

        if (curText.length > offset + curDel.length) {
          results.splice(actInd + 2, 0, new TextSegment(curText.substring(offset + curDel.length), flowDir, segDir));
        }

        results[actInd].text = curText.substring(0, offset);
        count++;

        if (stopIn > 0 && count === stopIn) {
          break;
        }
      }

      ind++;

      if (ind === results.length) {
        break;
      } else {
        continue;
      }
    }

    return results;
  };

  Bidi.handleSTT = function handleSTT(text, outType, sttType, pdelimiters, pflowDir, psegDir, pfindFromEnd, pstopIn) {
    if (pdelimiters === void 0) {
      pdelimiters = '';
    }

    if (pflowDir === void 0) {
      pflowDir = DEFAULT_DIR;
    }

    if (psegDir === void 0) {
      psegDir = DEFAULT_DIR;
    }

    if (pfindFromEnd === void 0) {
      pfindFromEnd = false;
    }

    if (pstopIn === void 0) {
      pstopIn = 0;
    }

    if (!text || !Bidi.isBidi() || sttType === Bidi.FREETEXT) {
      return text;
    }

    var delimiters = pdelimiters;
    var flowDir = pflowDir;
    var segDir = psegDir;
    var findFromEnd = pfindFromEnd;
    var stopIn = pstopIn;
    var guiDir = Bidi.isMirroredUI() ? RTL : LTR;

    switch (sttType) {
      case Bidi.EMAIL:
        delimiters = '<>.:,;@';
        flowDir = Bidi.getUserLanguage() === 'ar' && hasArabicChar(text, '@') ? RTL : LTR;
        break;

      case Bidi.FILEPATH:
        delimiters = '/\\:.';
        flowDir = LTR;
        break;

      case Bidi.FORMULA:
        delimiters = ' /%^&[]<>=!?~:.,|()+-*{}';
        flowDir = LTR;
        break;

      case Bidi.URL:
        delimiters = ':?#/@.[]=&';
        flowDir = LTR;
        break;

      case Bidi.BREADCRUMB:
        flowDir = flowDir === DEFAULT_DIR ? guiDir : flowDir;

        if (!delimiters) {
          delimiters = flowDir === RTL ? [' < ', ' | '] : [' > ', ' | '];
        }

        break;

      case Bidi.WORD:
        delimiters = ' ,.!?;:';
        break;

      case Bidi.COMMA:
        delimiters = ',';
        break;

      case Bidi.UNDERSCORE:
        delimiters = '_';
        break;

      case Bidi.FILENAME:
        delimiters = '.';
        flowDir = LTR;
        findFromEnd = true;
        stopIn = 1;
        break;

      case Bidi.CUSTOM:
        if (!delimiters) {
          return text;
        }

        break;

      default:
        return text;
    }

    var segments = Bidi.parse(text, sttType, delimiters, flowDir, segDir, findFromEnd, stopIn);
    var results = [];
    var i = 0;

    for (i = 0; i < segments.length; i++) {
      var segment = segments[i];
      var txt = segment.text;
      var actDir = segment.flowDir !== segment.segDir ? Bidi.resolveDir(txt, segment.segDir) : segment.flowDir;

      if (!segment.isSeparator) {
        if (actDir !== segment.flowDir) {
          txt = Bidi.enforceDir(txt, outType, actDir, false, i);
        }
      } else {
        txt = Bidi.isolate(txt, outType, segment.flowDir, i);
      }

      results.push(txt);
    }

    if (outType !== Bidi.AS_JSX) {
      var res = results.join('');

      if (outType === Bidi.AS_STRING) {
        res = (Bidi.resolveDir(res, flowDir) === RTL ? RLE : LRE) + res + PDF;
      } else {
        res = "<bdi dir='" + flowDir + "'>" + res + "</bdi>";
      }

      return res;
    }

    return /*#__PURE__*/_react["default"].createElement("bdi", {
      dir: flowDir
    }, results);
  };

  Bidi.removeUCC = function removeUCC(text) {
    if (!text) {
      return text;
    }

    return text.replace(/(['\u202A' | '\u202B' | '\u202C' | '\u200E' | '\u200F'])/g, '');
  };

  Bidi.isBidiMark = function isBidiMark(text) {
    if (!text) {
      return false;
    }

    return ["\u202A", "\u202B", "\u202C", "\u200E", "\u200F"].some(function (item) {
      return item === text.charAt(0);
    });
  };

  Bidi.checkDels = function checkDels(event) {
    var key = event.keyCode || event.charCode;

    if (key !== 8 && key !== 46) {
      return;
    }

    var text = event.target.value;
    var start = event.target.selectionStart;
    var end = event.target.selectionEnd;
    var as = start;
    var offs = key === 8 ? -1 : 1;

    if (start !== end) {
      return;
    }

    if (key === 8) {
      // backsp
      as -= 1;
    }

    while (as >= 0 && Bidi.isBidiMark(text.charAt(as))) {
      start += offs;
      as += offs;
    }

    event.target.selectionStart = start;
    event.target.selectionEnd = start;
  };

  Bidi.getDefBidi = function getDefBidi() {
    return false;
  };

  Bidi.isBidi = function isBidi() {
    if (Bidi.hasInitParams()) {
      return Bidi.getCustBidi();
    } else {
      return Bidi.getDefBidi();
    }
  };

  Bidi.getCustBidi = function getCustBidi() {
    return Bidi.custBidi;
  };

  Bidi.getCustBTD = function getCustBTD() {
    return Bidi.custBTD;
  };

  Bidi.getDefDir = function getDefDir() {
    if (Bidi.isMirroredUI()) {
      return RTL;
    } else {
      return LTR;
    }
  };

  Bidi.getDefBTD = function getDefBTD() {
    if (Bidi.isMirroredUI()) {
      return 'auto';
    } else {
      return '';
    }
  };

  Bidi._getTextDir = function _getTextDir() {
    if (Bidi.hasInitParams()) {
      return Bidi.getCustBTD();
    } else {
      return Bidi.getDefBTD();
    }
  };

  Bidi.getNumShape = function getNumShape() {
    if (Bidi.custNumShape) {
      return Bidi.custNumShape;
    } else {
      return Bidi.getDefNumShape();
    }
  };

  Bidi.getDefNumShape = function getDefNumShape() {
    if (Bidi.getUserLanguage() === 'ar') {
      return true;
    }

    return false;
  };

  Bidi.hasInitParams = function hasInitParams() {
    if (typeof Bidi.custBTD !== 'undefined' && typeof Bidi.custBidi !== 'undefined') {
      return true;
    } else {
      return false;
    }
  };

  Bidi.initParams = function initParams(bidi, btd, lang, numShape) {
    Bidi.custBTD = btd;
    Bidi.custBidi = bidi;
    Bidi.custLang = lang;

    if (numShape && Bidi.getUserLanguage() === 'ar') {
      Bidi.custNumShape = numShape;
    } else {
      Bidi.custNumShape = false;
    }
  };

  Bidi._getDir = function _getDir() {
    if (Bidi.getCustDir) {
      return Bidi.getCustDir();
    } else {
      return Bidi.getDefDir();
    }
  };

  Bidi.getDefLang = function getDefLang() {
    var html = document.documentElement;

    if (html.lang) {
      return html.lang;
    } else {
      return window.navigator.languages ? window.navigator.languages[0] : window.navigator.language || window.navigator.userLanguage;
    }
  };

  Bidi.getUserLanguage = function getUserLanguage() {
    if (Bidi.custLang) {
      return Bidi.custLang;
    } else {
      return Bidi.getDefLang();
    }
  };

  Bidi.isMirroredUI = function isMirroredUI() {
    var html = document.documentElement;

    if (window.getComputedStyle) {
      return computedDirection === RTL;
    } else if (html.dir) {
      return html.dir === RTL;
    } else {
      return false;
    }
  };

  Bidi.getBidiProps = function getBidiProps() {
    return ['dir', 'pagedir', 'pageTextDir', 'textDir', 'numShape', 'pageNumShape'];
  };

  (0, _createClass2["default"])(Bidi, null, [{
    key: "AS_STRING",
    get: function get() {
      return 1;
    }
  }, {
    key: "AS_HTML",
    get: function get() {
      return 2;
    }
  }, {
    key: "AS_JSX",
    get: function get() {
      return 3;
    }
  }, {
    key: "DIR_DEFAULT",
    get: function get() {
      return DEFAULT_DIR;
    }
  }, {
    key: "DIR_LTR",
    get: function get() {
      return LTR;
    }
  }, {
    key: "DIR_RTL",
    get: function get() {
      return RTL;
    }
  }, {
    key: "DIR_CONTEXTUAL",
    get: function get() {
      return CONTEXTUAL;
    }
  }, {
    key: "DIR_AUTO",
    get: function get() {
      return AUTO;
    }
  }, {
    key: "FREETEXT",
    get: function get() {
      return '0';
    }
  }, {
    key: "BREADCRUMB",
    get: function get() {
      return '1';
    }
  }, {
    key: "COMMA",
    get: function get() {
      return '2';
    }
  }, {
    key: "EMAIL",
    get: function get() {
      return '3';
    }
  }, {
    key: "FILEPATH",
    get: function get() {
      return '4';
    }
  }, {
    key: "FORMULA",
    get: function get() {
      return '5';
    }
  }, {
    key: "UNDERSCORE",
    get: function get() {
      return '6';
    }
  }, {
    key: "URL",
    get: function get() {
      return '7';
    }
  }, {
    key: "WORD",
    get: function get() {
      return '8';
    }
  }, {
    key: "FILENAME",
    get: function get() {
      return '9';
    }
  }, {
    key: "CUSTOM",
    get: function get() {
      return '99';
    }
  }]);
  return Bidi;
}();

exports["default"] = Bidi;

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = hoistInstance;

var _lodash = __webpack_require__(20);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var REACT_FUNCTIONS = {
  autobind: 1,
  childContextTypes: 1,
  componentDidMount: 1,
  componentDidUpdate: 1,
  componentWillMount: 1,
  componentWillReceiveProps: 1,
  componentWillUnmount: 1,
  componentWillUpdate: 1,
  contextTypes: 1,
  displayName: 1,
  forceUpdate: 1,
  getChildContext: 1,
  getDefaultProps: 1,
  getInitialState: 1,
  isMounted: 1,
  mixins: 1,
  render: 1,
  replaceProps: 1,
  replaceState: 1,
  setProps: 1,
  setState: 1,
  shouldComponentUpdate: 1,
  statics: 1,
  updateComponent: 1
};

function hoistInstance(dest, source) {
  (0, _lodash.forIn)(source, function (v, key) {
    if (typeof source[key] === 'function' && key.charAt(0) !== '_' && !REACT_FUNCTIONS[key] && dest[key] === undefined) {
      dest[key] = source[key].bind(source); // eslint-disable-line no-param-reassign
    }
  });
}

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__30__;

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toPairs = exports.uniqueId = exports.throttle = exports.sortBy = exports.result = exports.range = exports.groupBy = exports.pick = exports.omit = exports.isString = exports.isEqual = exports.isEmpty = exports.indexOf = exports.get = exports.forOwn = exports.forIn = exports.findIndex = exports.filter = exports.fill = exports.extend = exports.debounce = exports.cloneDeep = exports.clamp = exports.assign = void 0;

var _lodash = __webpack_require__(20);

exports.assign = _lodash.assign;
exports.clamp = _lodash.clamp;
exports.cloneDeep = _lodash.cloneDeep;
exports.debounce = _lodash.debounce;
exports.extend = _lodash.extend;
exports.fill = _lodash.fill;
exports.filter = _lodash.filter;
exports.findIndex = _lodash.findIndex;
exports.forIn = _lodash.forIn;
exports.forOwn = _lodash.forOwn;
exports.get = _lodash.get;
exports.indexOf = _lodash.indexOf;
exports.isEmpty = _lodash.isEmpty;
exports.isEqual = _lodash.isEqual;
exports.isString = _lodash.isString;
exports.omit = _lodash.omit;
exports.pick = _lodash.pick;
exports.groupBy = _lodash.groupBy;
exports.range = _lodash.range;
exports.result = _lodash.result;
exports.sortBy = _lodash.sortBy;
exports.throttle = _lodash.throttle;
exports.uniqueId = _lodash.uniqueId;
exports.toPairs = _lodash.toPairs;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(596);


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports.event = exports.arrayFilters = exports.listHelper = exports.mathUtils = exports.lodash = exports.keyboardUtils = exports.cssUtils = exports.propsUtils = exports.domUtils = exports.bidiUtils = void 0;

var bidiUtils = _interopRequireWildcard(__webpack_require__(597));

exports.bidiUtils = bidiUtils;

var domUtils = _interopRequireWildcard(__webpack_require__(598));

exports.domUtils = domUtils;

var propsUtils = _interopRequireWildcard(__webpack_require__(600));

exports.propsUtils = propsUtils;

var cssUtils = _interopRequireWildcard(__webpack_require__(601));

exports.cssUtils = cssUtils;

var keyboardUtils = _interopRequireWildcard(__webpack_require__(128));

exports.keyboardUtils = keyboardUtils;

var lodash = _interopRequireWildcard(__webpack_require__(34));

exports.lodash = lodash;

var mathUtils = _interopRequireWildcard(__webpack_require__(602));

exports.mathUtils = mathUtils;

var listHelper = _interopRequireWildcard(__webpack_require__(603));

exports.listHelper = listHelper;

var _Bidi = _interopRequireDefault(__webpack_require__(130));

exports.Bidi = _Bidi["default"];

var arrayFilters = _interopRequireWildcard(__webpack_require__(604));

exports.arrayFilters = arrayFilters;

var _StringResource = _interopRequireDefault(__webpack_require__(605));

exports.StringResource = _StringResource["default"];

var event = _interopRequireWildcard(__webpack_require__(608));

exports.event = event;

var _classnames = _interopRequireDefault(__webpack_require__(129));

exports.classnames = _classnames["default"];

var _hoistNonReactInstanceFunctions = _interopRequireDefault(__webpack_require__(132));

exports.hoistNonReactInstanceFunctions = _hoistNonReactInstanceFunctions["default"];

var _reactify = _interopRequireDefault(__webpack_require__(609));

exports.reactify = _reactify["default"];

var _delayMount = _interopRequireDefault(__webpack_require__(610));

exports.delayMount = _delayMount["default"];

var _debounceInput = _interopRequireDefault(__webpack_require__(611));

exports.debounceInput = _debounceInput["default"];

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.resolveBaseTextDir = resolveBaseTextDir;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/**
 * Checks if the character passed in is an Arabic character.
 * @param {string} charCode - Character code
 * @return {boolean} True, if character is an Arabic character, false otherwise
 */
function isArabicChar(charCode) {
  if (charCode >= 0x0600 && charCode <= 0x0669 || charCode >= 0x06fa && charCode <= 0x07ff || charCode >= 0xfb50 && charCode <= 0xfdff || charCode >= 0xfe70 && charCode <= 0xfefc) {
    return true;
  }

  return false;
}
/**
 * Checks if the character passed in is a Hebrew character.
 * @param {string} charCode - Character code
 * @return {boolean} True, if character is a Hebrew character, false otherwise
 */


function isHebrewChar(charCode) {
  if (charCode >= 0x05d0 && charCode <= 0x05ff) {
    return true;
  }

  return false;
}
/**
 * Checks if the character passed in is a BiDi character.
 * @param {number} charCode - Character code
 * @return {boolean} True, if the character is a BiDi (Arabic or Hebrew) character, false otherwise
 */


function isBidiChar(charCode) {
  return isArabicChar(charCode) || isHebrewChar(charCode);
}
/**
 * Checks if the character passed in is a Latin character (Only treats
 * capital and lower case alphabets as latin characters)
 * @param {number} charCode - Character code
 * @return {boolean} True if the character is a Latin character, false otherwise
 */


function isLatinChar(charCode) {
  if (charCode > 64 && charCode < 91 || charCode > 96 && charCode < 123) {
    return true;
  }

  return false;
}

function detectIE(useragent) {
  return /\b(MSIE|Trident|Edge)\b/.test(useragent);
}

var AUTO = 'auto';
var isIE = detectIE(navigator.userAgent);
/**
 * Traverses the string passed in as a parameter from the beginning and
 * determines the direction of the text based on the first strong character
 * @param {string} text - A bi-directional text
 * @param {bool} isTextArea - Does the text belong to a textarea
 * @return {string} Direction of the text
 */

function resolveBaseTextDir(text, textDir, isTextArea) {
  // eslint-disable-line import/prefer-default-export
  if (!textDir) {
    textDir = AUTO;
  }

  if (textDir === AUTO && (!isTextArea || isIE)) {
    for (var i = 0; text && i < text.length; i++) {
      var character = text.charCodeAt(i);

      if (isBidiChar(character)) {
        textDir = 'rtl';
        break;
      } else if (isLatinChar(character)) {
        textDir = 'ltr';
        break;
      }
    }

    if (isIE && textDir === AUTO) {
      textDir = '';
    }
  }

  return textDir;
}

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.getNearestPositionedParent = getNearestPositionedParent;
exports.getTransformedParentElement = getTransformedParentElement;
exports.getPathToRoot = getPathToRoot;
exports.scrollLock = scrollLock;
exports.scrollUnlock = scrollUnlock;
exports.getEventClientOffset = getEventClientOffset;
exports.getNodeClientOffset = getNodeClientOffset;
exports.getNodeDepth = getNodeDepth;
exports.getElementCenter = getElementCenter;
exports.getElementTopLeft = getElementTopLeft;
exports.getElementBottomLeft = getElementBottomLeft;
exports.offsetWithinBoundingRect = offsetWithinBoundingRect;
exports.applyAttributes = applyAttributes;
exports.scrollIntoViewIfNeeded = scrollIntoViewIfNeeded;
exports.isElementInView = isElementInView;
exports.enableFocusLoop = enableFocusLoop;
exports.resetFocusLoop = resetFocusLoop;
exports.getFocusableElements = getFocusableElements;
exports.availableSpace = availableSpace;
exports.autoPosition = autoPosition;
exports.fromNodelistToArray = fromNodelistToArray;
exports.setFocus = setFocus;
exports.disableFocusLoop = disableFocusLoop;
exports.computeTopWith = computeTopWith;
exports.computeLeftWith = computeLeftWith;
exports.computeWidthOf = computeWidthOf;
exports.IE11 = void 0;

var _keyboardUtils = __webpack_require__(128);

var _classnames = _interopRequireDefault(__webpack_require__(129));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var IE11 = !!window.MSInputMethodContext && !!document.documentMode;
exports.IE11 = IE11;

function getNearestPositionedParent(el) {
  var curEl = el.parentElement;

  while (curEl) {
    if (window.getComputedStyle(curEl).position !== 'static') {
      return curEl;
    }

    curEl = curEl.parentElement;
  }

  return document.body;
}
/**
 * Get the nearest parent element which has a CSS transform applied. If no such parent exists returns null.
 */


function getTransformedParentElement(node) {
  var el = node;

  do {
    if (el.nodeType === Node.ELEMENT_NODE && (el.style.transform || window.getComputedStyle(el).transform !== 'none')) {
      return el;
    }

    el = el.parentNode;
  } while (el);

  return null;
}
/**
 * Get a list of all parent nodes.
 */


function getPathToRoot(node) {
  var path = [];
  var p = node;

  while (p) {
    path.push(p);
    p = p.parentNode;
  }

  return path;
}

function isScrollableOverFlow(overflow) {
  return overflow === 'scroll' || overflow === 'auto';
}

function isScrollableNode(node) {
  var _window$getComputedSt = window.getComputedStyle(node),
      overflowX = _window$getComputedSt.overflowX,
      overflowY = _window$getComputedSt.overflowY,
      overflow = _window$getComputedSt.overflow;

  return isScrollableOverFlow(overflowX) || isScrollableOverFlow(overflowY) || isScrollableOverFlow(overflow);
} // an array of scroll locks


var scrollLocks = [];
/**
 * Determine whether or not the list of nodes contains a scrollable element iff the list also contains the current scroll lock.
 */

function hasScrollableElement(pathNodes) {
  var lockIndex = pathNodes.indexOf(scrollLocks[scrollLocks.length - 1]);

  for (var i = 0; i <= lockIndex; ++i) {
    if (pathNodes[i].nodeType === Node.ELEMENT_NODE) {
      var node = pathNodes[i];

      if (isScrollableNode(node)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * An event listener that prevents scrolling unless the event target is a child of the current scroll lock.
 */


function scrollLockHandler(e) {
  if (e.cancelable) {
    var tagName = e.target.tagName;

    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !hasScrollableElement(getPathToRoot(e.target))) {
      e.preventDefault();
    }
  }
}

function scrollLockHandlerKeyDown(e) {
  if (e.keyCode >= 37 && e.keyCode <= 40) {
    scrollLockHandler(e);
  }
}
/**
 * Lock scrolling on the page to the specified element.
 * Prevents scrolling of all elements on the page other than those that are descendent of the given element.
 */


function scrollLock(element) {
  if (scrollLocks.indexOf(element) >= 0) {
    return;
  }

  if (scrollLocks.length === 0) {
    document.addEventListener('keydown', scrollLockHandlerKeyDown, true);
    document.addEventListener('wheel', scrollLockHandler, true);
    document.addEventListener('mousewheel', scrollLockHandler, true);
    document.addEventListener('touchstart', scrollLockHandler, true);
    document.addEventListener('touchmove', scrollLockHandler, true); // IE

    document.addEventListener('DOMMouseScroll', scrollLockHandler, true);
  }

  scrollLocks.push(element);
}
/**
 * Unlocks scrolling which was previously locked by the given element.
 */


function scrollUnlock(element) {
  var index = scrollLocks.indexOf(element);

  if (index === -1) {
    return;
  }

  scrollLocks.splice(index, 1);

  if (scrollLocks.length === 0) {
    document.removeEventListener('keydown', scrollLockHandlerKeyDown, true);
    document.removeEventListener('wheel', scrollLockHandler, true);
    document.removeEventListener('mousewheel', scrollLockHandler, true);
    document.removeEventListener('touchstart', scrollLockHandler, true);
    document.removeEventListener('touchmove', scrollLockHandler, true); // IE

    document.removeEventListener('DOMMouseScroll', scrollLockHandler, true);
  }
}
/**
 * Gets an x,y offset from a mouse event
 */


function getEventClientOffset(e) {
  var clientX;
  var clientY; // get the underlying event in the case of jquery

  var event = e.originalEvent || e;
  var touches = event.type === 'touchend' ? event.changedTouches : event.touches;

  if (touches && touches.length) {
    var _touches$ = touches[0];
    clientX = _touches$.clientX;
    clientY = _touches$.clientY;
  } else {
    clientX = e.clientX;
    clientY = e.clientY;
  }

  return {
    x: clientX,
    y: clientY
  };
}
/**
 * Gets an x,y offset from nearest element
 */


function getNodeClientOffset(node) {
  var el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return {
    x: left,
    y: top
  };
}
/**
 * Gets the depth of a node within its tree
 */


function getNodeDepth(node) {
  var depth = 0;
  var n = node;

  while (n) {
    depth += 1;
    n = n.parentNode;
  }

  return depth;
}
/**
 * Get the center of the bounding rect of the element
 */


function getElementCenter(el) {
  var rect = el.getBoundingClientRect();
  var x = Math.round(rect.left + rect.width / 2);
  var y = Math.round(rect.top + rect.height / 2);
  return {
    x: x,
    y: y
  };
}
/**
 * Get the top left of the bounding rect of the element
 */


function getElementTopLeft(el) {
  var rect = el.getBoundingClientRect();
  var x = Math.round(rect.left);
  var y = Math.round(rect.top);
  return {
    x: x,
    y: y
  };
}
/**
 * Get the top left of the bounding rect of the element
 */


function getElementBottomLeft(el) {
  var rect = el.getBoundingClientRect();
  var x = Math.round(rect.left);
  var y = Math.round(rect.bottom);
  return {
    x: x,
    y: y
  };
}

function offsetWithinBoundingRect(clientOffset, boundingRect) {
  return clientOffset.x >= boundingRect.left && clientOffset.x < boundingRect.right && clientOffset.y >= boundingRect.top && clientOffset.y < boundingRect.bottom;
}

function applyAttributes(el, attrs) {
  var attrKeys = Object.keys(attrs);

  for (var i = 0; i < attrKeys.length; i++) {
    var attrKey = attrKeys[i];

    if (attrKey === 'style') {
      var style = attrs[attrKey];

      if (!style || typeof style !== 'object') {
        throw new Error('applyAttributes: Expected style to be an object');
      }

      var styleNames = Object.keys(style);

      for (var j = 0; j < styleNames.length; j++) {
        var styleName = styleNames[j];
        el.style[styleName] = style[styleName];
      }
    } else if (attrKey === 'className') {
      (function () {
        var className = attrs[attrKey];

        if (typeof className === 'string') {
          var classes = className.split(' ');

          for (var _j = 0; _j < classes.length; _j++) {
            el.classList.add(classes[_j]);
          }
        } else {
          // object
          Object.keys(className).forEach(function (cn) {
            if (className[cn]) {
              el.classList.add(cn);
            } else {
              el.classList.remove(cn);
            }
          });
        }
      })();
    } else if (attrKey === 'class') {
      throw new Error('applyAttributes: Unexpected attribute "class", use "className" instead.');
    } else {
      el.setAttribute(attrKey, attrs[attrKey]);
    }
  }
}
/**
 * Vertical cross browser support for experimental DOM API #scrollIntoViewIfNeeded
 * This function will only scroll vertically.
 */


function scrollIntoViewIfNeeded(scrollNode, node) {
  if (node.scrollIntoViewIfNeeded) {
    node.scrollIntoViewIfNeeded();
  } else {
    var sOffsetTop = scrollNode.offsetTop;
    var sScrollTop = scrollNode.scrollTop;
    var sClientHeight = scrollNode.clientHeight;
    var nOffsetTop = node.offsetTop;
    var nClientHeight = node.clientHeight;
    var nTop = nOffsetTop - sOffsetTop;
    var overTop = nTop < sScrollTop;

    if (overTop && nTop + nClientHeight > sScrollTop) {
      // move to top
      scrollNode.scrollTop = nTop;
    }

    var overBottom = nTop + nClientHeight > sScrollTop + sClientHeight;

    if (overBottom && nTop < sScrollTop + sClientHeight) {
      // move to bottom
      scrollNode.scrollTop = sScrollTop + (nTop + nClientHeight - (sScrollTop + sClientHeight));
    } else if (overTop || overBottom) {
      // center
      scrollNode.scrollTop = nTop - sClientHeight / 2 + nClientHeight / 2;
    }
  }
}

function isElementInView(el, parent) {
  if (parent === void 0) {
    parent = document.documentElement;
  }

  var rect = el.getBoundingClientRect();
  var parentRect = parent.getBoundingClientRect();
  return rect.top >= parentRect.top && rect.left >= parentRect.left && rect.bottom <= parentRect.bottom && rect.right <= parentRect.right;
}
/**
 * Creates two headers so that only the elements between the two headers are tabable
 * Argument: tabEnabledArea: DOM element
 */


function enableFocusLoop(tabEnabledArea, index, ariaLabel) {
  var focusIndex = index || 0;
  var tabKeyPressed = false;
  var entryHeader = document.createElement('div');
  entryHeader.setAttribute('tabindex', '0');
  entryHeader.setAttribute('style', 'width: 0; height: 0; outline: none');

  if (ariaLabel) {
    entryHeader.setAttribute('aria-label', ariaLabel);
  }

  var exitHeader = document.createElement('div');
  exitHeader.setAttribute('tabindex', '0');
  exitHeader.setAttribute('style', 'width: 0; height: 0; outline: none');
  tabEnabledArea.insertBefore(entryHeader, tabEnabledArea.childNodes[0]);
  tabEnabledArea.appendChild(exitHeader);
  tabEnabledArea.addEventListener('keydown', function (e) {
    (0, _keyboardUtils.getKeyName)(e) === _keyboardUtils.keyNames.TAB && (tabKeyPressed = true, e.target.classList.remove((0, _classnames["default"])('focus')));
  });
  var nodesArray = getFocusableElements(tabEnabledArea);
  var _document = document,
      activeElement = _document.activeElement;
  (focusIndex < 0 || focusIndex > nodesArray.length - 2) && !tabEnabledArea.contains(activeElement) && setTimeout(function () {
    return entryHeader.focus();
  }, 0);
  setTimeout(function () {
    tabEnabledArea.contains(activeElement) && activeElement.focus();
    entryHeader.addEventListener('focus', function (e) {
      e.preventDefault();
      var nodesArray = getFocusableElements(tabEnabledArea);

      if (tabKeyPressed) {
        nodesArray[nodesArray.length - 2].focus();
        tabKeyPressed = false;
      }
    }, 0);
    exitHeader.addEventListener('focus', function (e) {
      e.preventDefault();
      var nodesArray = getFocusableElements(tabEnabledArea);

      if (tabKeyPressed) {
        nodesArray[1].focus();
        tabKeyPressed = false;
      }
    });
  });
  focusIndex > -1 && focusIndex < nodesArray.length - 2 && !tabEnabledArea.contains(activeElement) && setFocus(nodesArray[focusIndex + 1]);
}

function resetFocusLoop(tabEnabledArea) {
  var nodesArray = getFocusableElements(tabEnabledArea);

  if (!tabEnabledArea.contains(document.activeElement)) {
    nodesArray[0].focus();
  }
}

function getFocusableElements(tabEnabledArea) {
  var focusableElements = tabEnabledArea.querySelectorAll('button:not([tabindex="-1"]):not([disabled]), [href]:not([tabindex="-1"]):not([disabled]), input:not([tabindex="-1"]):not([disabled]), select:not([tabindex="-1"]):not([disabled]), textarea:not([tabindex="-1"]):not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'); // filter out all svg items or elements with undefined 'focus' function

  return fromNodelistToArray(focusableElements).filter(function (item) {
    return !(item instanceof SVGElement || typeof item.focus !== 'function' || item.type === 'radio' && !item.checked);
  });
}
/**
 * Calculates the available space for a flyout container and returns an object containing x and y locations
 * Argument: trigger: DOM element that triggers the flyout container,
 *           target: DOM element, the flyout container,
 *           defaultPosition (Optional): Object contains default x and y locations
 */


function availableSpace(element) {
  var elementRect = element.getBoundingClientRect();
  var availableRoomLeft = elementRect.left;
  var availableRoomRight = window.innerWidth - elementRect.right;
  var availableRoomTop = elementRect.top;
  var availableRoomBottom = window.innerHeight - elementRect.bottom;
  return {
    top: availableRoomTop,
    right: availableRoomRight,
    bottom: availableRoomBottom,
    left: availableRoomLeft
  };
}

function autoPosition(availableSpace, targetDimension, defaultPosition) {
  var targetHeight = targetDimension.height;
  var targetWidth = targetDimension.width;
  var possibleSpots = [];

  if (availableSpace.top >= targetHeight && availableSpace.right >= targetWidth / 2 && availableSpace.left >= targetWidth / 2) {
    possibleSpots.push('top');
  }

  if (availableSpace.bottom >= targetHeight && availableSpace.right >= targetWidth / 2 && availableSpace.left >= targetWidth / 2) {
    possibleSpots.push('bottom');
  }

  if (availableSpace.right >= targetWidth && availableSpace.top >= targetHeight / 2 && availableSpace.bottom >= targetHeight / 2) {
    possibleSpots.push('right');
  }

  if (availableSpace.left >= targetWidth && availableSpace.top >= targetHeight / 2 && availableSpace.bottom >= targetHeight / 2) {
    possibleSpots.push('left');
  }

  if (defaultPosition && possibleSpots.indexOf(defaultPosition) > -1) {
    return defaultPosition;
  } else if (possibleSpots.length > 0) {
    return possibleSpots[0];
  }

  return 'top';
}

function fromNodelistToArray(nodelist) {
  return Array.prototype.slice.apply(nodelist);
}

function setFocus(focusableElement) {
  focusableElement.focus();
  focusableElement.classList.add((0, _classnames["default"])('focus'));
}

function disableFocusLoop(tabEnabledArea) {
  var focusableElements = tabEnabledArea.querySelectorAll('[tabindex]:not([tabindex="-1"])');
  var nodesArray = fromNodelistToArray(focusableElements);
  nodesArray.forEach(function (item) {
    item.removeEventListener('focus', setFocus);
  });
  tabEnabledArea.removeEventListener('click', setFocus);
}
/**
 * Computes the position of an element - used for tooltip triggers
 * Argument: elem: DOM element that triggers the tooltip
 */


function computeTopWith(elem) {
  var box = elem.getBoundingClientRect();
  var _document2 = document,
      body = _document2.body;
  var element = elem;
  var scrollTop = window.pageYOffset || element.scrollTop || body.scrollTop;
  var clientTop = element.clientTop || body.clientTop || 0;
  var top = box.top + scrollTop - clientTop;
  return Math.round(top);
}

function computeLeftWith(elem) {
  var box = elem.getBoundingClientRect();
  var _document3 = document,
      body = _document3.body;
  var element = elem;
  var scrollLeft = window.pageXOffset || element.scrollLeft || body.scrollLeft;
  var clientLeft = element.clientLeft || body.clientLeft || 0;
  var left = box.left + scrollLeft - clientLeft;
  return Math.round(left);
}

function computeWidthOf(elem) {
  return Math.round(elem.getBoundingClientRect().width);
}

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.sanitize = sanitize;
exports.getInheritedProps = getInheritedProps;
exports.BaPropTypes = void 0;

var _lodash = __webpack_require__(34);

var _Bidi = _interopRequireDefault(__webpack_require__(130));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function createError(propFullName, componentName) {
  return new Error("Invalid prop '" + propFullName + "' supplied to '" + componentName + "'. Validation failed.");
}

var BaPropTypes = {
  component: function component(_component) {
    return function (propValue, key, componentName, location, propFullName) {
      var prop = propValue[key];

      if (prop.type !== _component && prop.type.name !== _component.name) {
        return createError(propFullName, componentName);
      }

      return undefined;
    };
  },
  range: function range(min, max) {
    return function (propValue, key, componentName, location, propFullName) {
      var value = propValue[key];

      if (value != null && (value < min || value > max)) {
        return createError(propFullName, componentName);
      }

      return undefined;
    };
  },
  notAllowed: function notAllowed(notAllowedValues, message) {
    return function (propValue, key, componentName) {
      var value = propValue[key];
      var passed = true;

      for (var i = 0; i < notAllowedValues.length; i++) {
        if (value === notAllowedValues[i]) {
          passed = false;
          break;
        }
      }

      if (value != null && !passed) {
        return new Error("Invalid prop '" + key + "' supplied to '" + componentName + "'. " + (message || ''));
      }

      return undefined;
    };
  },
  deprecated: function deprecated(message) {
    return function (propValue, key, componentName) {
      var value = propValue && propValue[key];

      if (value != null) {
        return new Error("'" + key + "' supplied to '" + componentName + "' is deprecated . " + (message || ''));
      }

      return undefined;
    };
  },
  deprecatedByCarbon: function deprecatedByCarbon(Component) {
    BaPropTypes.deprecated("It is ignored and not applicable to Carbon " + Component.name);
  },
  requiredIf: function requiredIf(typeCheck, condition) {
    return function (props, propName, componentName) {
      // if condition is not provided we will assume required is true
      var isRequired = typeof condition === 'function' ? condition(props, propName, componentName) : true;

      if (!typeCheck) {
        return new Error("Unable to validate " + propName + " for " + componentName + ", type check method not provided.");
      }

      var check = isRequired ? typeCheck.isRequired : typeCheck;

      for (var _len = arguments.length, other = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        other[_key - 3] = arguments[_key];
      }

      return check.apply(void 0, [props, propName, componentName].concat(other));
    };
  }
};
exports.BaPropTypes = BaPropTypes;

function sanitize(props, Component) {
  // Predefined blackList, can be added more if needed
  var defaultBlackList = [].concat(Component ? Object.keys(Component.propTypes) : [], _Bidi["default"].getBidiProps());

  for (var _len2 = arguments.length, blackList = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    blackList[_key2 - 2] = arguments[_key2];
  }

  var blackLists = [].concat(blackList, defaultBlackList);
  return _lodash.omit.apply(void 0, [props].concat(blackLists));
}

function getInheritedProps(props, SuperClass) {
  return (0, _lodash.pick)(props, [].concat(Object.keys(SuperClass.propTypes)));
}

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.cssSize = cssSize;
exports.sizeArrayToCss = sizeArrayToCss;
exports.mergeStyles = mergeStyles;
exports.sizeStep = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _lodash = __webpack_require__(34);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sizeStep = 8;
exports.sizeStep = sizeStep;

function cssSize(n) {
  return n * sizeStep;
}

function sizeArrayToCss(sizeArray) {
  if (sizeArray == null) {
    return sizeArray;
  }

  var arr = Array.isArray(sizeArray) ? sizeArray : [+sizeArray];
  return arr.length ? arr.map(function (v) {
    return v * sizeStep;
  }).join('px ') + "px" : null;
}

function mergeStyles(a, b) {
  if (!b) {
    return a;
  }

  var styles = (0, _extends2["default"])({}, a);
  (0, _lodash.forIn)(b, function (value, key) {
    if (styles[key] == null && value != null) {
      styles[key] = value;
    }
  });
  return styles;
}

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.decimalPlaces = decimalPlaces;
exports.decimalMultiply = decimalMultiply;
exports.decimalPlus = decimalPlus;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function decimalPlaces(number) {
  if (Math.floor(number) === number) {
    return 0;
  }

  return number.toString().split('.')[1].length || 0;
}

function decimalMultiply(a, b) {
  var powerOf10a = Math.pow(10, decimalPlaces(a));
  var powerOf10b = Math.pow(10, decimalPlaces(b));
  return a * powerOf10a * (b * powerOf10b) / (powerOf10a * powerOf10b);
}

function decimalPlus(a, b) {
  var powerOf10 = Math.pow(10, Math.max(decimalPlaces(a), decimalPlaces(b)));
  return (a * powerOf10 + b * powerOf10) / powerOf10;
}

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.getSelected = getSelected;
exports.indexKeyGetter = indexKeyGetter;
exports.singleSelect = singleSelect;
exports.clear = clear;
exports.invert = invert;
exports.multiSelect = multiSelect;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _constants = __webpack_require__(30);

var _lodash = __webpack_require__(34);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var selectionEventTypes = _constants.listEventTypes.selectionEventTypes;
/**
 * Get the array of selected data elements from the provided selection map.
 *
 * @param {Object} selectedMap a map of selected values
 *
 * @return {Object[]} an array of selected data elements
 */

function getSelected(selectedMap) {
  var result = [];
  (0, _lodash.forOwn)(selectedMap, function (value, i) {
    if (selectedMap[i] != null) {
      result.push(selectedMap[i]);
    }
  });
  return result;
}
/**
 * A key getter that simply returns the index provided.
 *
 * @param {number} index the index of the data element
 *
 * @return {number} the index of the data element
 */


function indexKeyGetter(index) {
  return index;
}
/**
 * Handles events for single selection mode lists.
 *
 * @param {Object} event the list selection event
 * @param {Object[]} data the array of data elements
 * @param {string} selectedKey the current selected key value
 * @param {keyGetterCallback} keyGetter
 *
 * @return {string} the key of the selected element
 */


function singleSelect(event, data, selectedKey, keyGetter) {
  var getter = keyGetter || indexKeyGetter;
  var key = getter(event.index);

  if (event.type === selectionEventTypes.TOGGLE && selectedKey === key) {
    return null;
  }

  return key;
}
/**
 * Clears all data elements from the given selection map.
 *
 * @param {Object[]} data the array of data elements to clear
 * @param {Object} selectedMap a map of selected values
 * @param {keyGetterCallback} keyGetter
 * @param {Object} omit a map of items to omit from changing selection
 *
 * @return {Object} the new selection map
 */


function clear(data, selectedMap, keyGetter, omit) {
  var getter = keyGetter || indexKeyGetter;
  var newSelection = (0, _extends2["default"])({}, selectedMap);
  data.forEach(function (d, i) {
    var key = getter(i);

    if (selectedMap[key] && (!omit || !omit[key])) {
      newSelection[key] = null;
    }
  });
  return newSelection;
}
/**
 * Inverts the selection of all data elements from the given selection map.
 *
 * @param {Object[]} data the array of data elements to invert
 * @param {Object} selectedMap a map of selected values
 * @param {keyGetterCallback} keyGetter
 * @param {Object} omit a map of items to omit from changing selection
 *
 * @return {Object} the new selection map
 */


function invert(data, selectedMap, keyGetter, omit) {
  var getter = keyGetter || indexKeyGetter;
  var newSelection = (0, _extends2["default"])({}, selectedMap);
  data.forEach(function (d, i) {
    var key = getter(i);

    if (!omit || !omit[key]) {
      if (!selectedMap[key]) {
        newSelection[key] = data[i];
      } else {
        newSelection[key] = null;
      }
    }
  });
  return newSelection;
}
/**
 * Handles events for multi selection mode lists.
 *
 * @param {Object} event the list selection event
 * @param {Object[]} data the array of data elements
 * @param {string} selectedKey the current selected key value
 * @param {keyGetterCallback} keyGetter
 * @param {Object} omit a map of items to omit from changing selection
 *
 * @return {string} the key of the selected element
 */


function multiSelect(event, data, selectedMap, keyGetter, omit) {
  var eventType = event.type;
  var getter = keyGetter || indexKeyGetter;
  var result = {
    selectedCount: 0,
    deselectedCount: 0
  };
  var rselectedMap = selectedMap;
  var key;
  var index = event.index;

  switch (eventType) {
    case selectionEventTypes.SET:
      key = getter(index);

      if (!omit) {
        var total = Object.keys(selectedMap).length;

        if (total !== 1 || !selectedMap[key]) {
          var _rselectedMap;

          rselectedMap = (_rselectedMap = {}, _rselectedMap[key] = data[index], _rselectedMap);
          result.selected = data[index];
          result.selectedCount = 1;
          result.deselectedCount = total;
        }
      } else if (!omit[key] && !selectedMap[key]) {
        rselectedMap = (0, _extends2["default"])({}, selectedMap);
        result.selected = data[index];
        rselectedMap[key] = data[index];
        result.selectedCount = 1;
      }

      break;

    default:
      rselectedMap = (0, _extends2["default"])({}, selectedMap);

      switch (eventType) {
        case selectionEventTypes.ADD:
          key = getter(index);

          if (!rselectedMap[key] && (!omit || !omit[key])) {
            rselectedMap[key] = data[index];
            result.selected = data[index];
            result.selectedCount = 1;
          }

          break;

        case selectionEventTypes.REMOVE:
          key = getter(index);

          if (rselectedMap[key] && (!omit || !omit[key])) {
            delete rselectedMap[key];
            result.deselected = data[index];
            result.deselectedCount = 1;
          }

          break;

        case selectionEventTypes.COMPOSITE:
          if (event.added) {
            event.added.forEach(function (i) {
              key = getter(i);

              if (!rselectedMap[key] && (!omit || !omit[key])) {
                rselectedMap[key] = data[i];
                result.selected = data[index];
                result.selectedCount += 1;
              }
            });
          }

          if (event.removed) {
            event.removed.forEach(function (i) {
              key = getter(i);

              if (rselectedMap[key] && (!omit || !omit[key])) {
                delete rselectedMap[key];
                result.deselected = data[index];
                result.deselectedCount += 1;
              }
            });
          }

          break;

        case selectionEventTypes.TOGGLE:
          key = getter(index);

          if (!omit || !omit[key]) {
            if (rselectedMap[key]) {
              delete rselectedMap[key];
              result.deselected = data[index];
              result.deselectedCount = 1;
            } else {
              rselectedMap[key] = data[index];
              result.selected = data[index];
              result.selectedCount = 1;
            }
          }

          break;

        case selectionEventTypes.SELECT_ALL:
          data.forEach(function (d, i) {
            key = getter(i);

            if (!rselectedMap[key] && (!omit || !omit[key])) {
              rselectedMap[key] = data[i];
              result.selected = data[index];
              result.selectedCount += 1;
            }
          });
          break;

        default:
      }

  }

  result.selectedMap = rselectedMap;
  return result;
}

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.startsWithFilter = startsWithFilter;
exports.containsFilter = containsFilter;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

/**
 * Adds common input pre-processing for filter functions.
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @param filterFn {Function} - array filter function to call
 * @returns {Function} - new array filter function with common pre-processing
 */
function createFilter(input, caseSensitive, filterFn) {
  if (input === void 0) {
    input = '';
  }

  if (caseSensitive === void 0) {
    caseSensitive = false;
  }

  return function (value) {
    if (value === void 0) {
      value = '';
    }

    // value could be a string or an object from a comboBox - { value, label }
    value = typeof value === 'string' ? value : value.label || '';
    input = input.trim();

    if (!caseSensitive) {
      value = value.toLowerCase();
      input = input.toLowerCase();
    }

    if (value === input) {
      return true;
    }

    return filterFn(input, value);
  };
}
/**
 * Creates a 'starts with' array filter function
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @returns {Function} - array filter function
 */


function startsWithFilter(input, caseSensitive) {
  return createFilter(input, caseSensitive, function (input, value) {
    return value.substring(0, input.length) === input;
  });
}
/**
 * Creates a 'contains' array filter function
 *
 * @param input {string} - value to filter on.
 * @param caseSensitive {boolean} - optional, defaults to false.
 * @returns {Function} - array filter function
 */


function containsFilter(input, caseSensitive) {
  return createFilter(input, caseSensitive, function (input, value) {
    return value.indexOf(input) >= 0;
  });
}

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _nodePolyglot = _interopRequireDefault(__webpack_require__(606));

var _DefaultResources = _interopRequireDefault(__webpack_require__(607));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var StringResource = function StringResource(resources) {
  var allResources = Object.assign({}, _DefaultResources["default"], resources);
  this._polyglot = new _nodePolyglot["default"]({
    phrases: allResources
  });
};
/**
 * Get the string resource for the given key and interpolation options
 *
 * @param key The  key of the string to return
 * @param interpolationOptions Optional interpolation options (see poly.t documentation for details)
 * @returns The string to display
 */


StringResource.prototype.get = function (key, interpolationOptions) {
  var translated = this._polyglot.t(key, interpolationOptions);

  if (this._polyglot.phrases[key] === undefined) {
    translated = "__NOT_TRANSLATED__(" + key + ")";
  }

  return translated;
};

var _default = StringResource;
exports["default"] = _default;

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports = require("node-polyglot");

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

var amdi18n={"__root":{},"__cs":{},"__da":{},"__de":{},"__es":{},"__fi":{},"__fr":{},"__hr":{},"__hu":{},"__it":{},"__ja":{},"__kk":{},"__ko":{},"__nb":{},"__nl":{},"__no":{},"__pl":{},"__pt":{},"__pt-br":{},"__ro":{},"__ru":{},"__sl":{},"__sv":{},"__th":{},"__tr":{},"__zh":{},"__zh-cn":{},"__zh-tw":{}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.stopEvent = stopEvent;

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-carbon-toolkit (C) Copyright IBM Corp. 2016, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
function stopEvent(e) {
  // eslint-disable-line import/prefer-default-export
  e.preventDefault();
  e.stopPropagation();
}

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = _default;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _createClass2 = _interopRequireDefault(__webpack_require__(131));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _default(CustomElement, _ref) {
  var _ref$events = _ref.events,
      events = _ref$events === void 0 ? {} : _ref$events,
      _ref$mapAttributes = _ref.mapAttributes,
      mapAttributes = _ref$mapAttributes === void 0 ? function () {
    return {};
  } : _ref$mapAttributes,
      _ref$mapProperties = _ref.mapProperties,
      mapProperties = _ref$mapProperties === void 0 ? function () {
    return {};
  } : _ref$mapProperties,
      onRender = _ref.onRender,
      onUnmount = _ref.onUnmount;
  var tagName;

  var getTagName = function getTagName() {
    return tagName || (tagName = new CustomElement().tagName);
  };

  function isNativeEvent(eventName) {
    return eventName.indexOf('on') === 0 && eventName[2] === eventName[2].toUpperCase() && !events[eventName];
  }

  var Comp = /*#__PURE__*/function (_React$Component) {
    (0, _inheritsLoose2["default"])(Comp, _React$Component);

    function Comp() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = Comp.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.componentWillReceiveProps(this.props, {});
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(props, prevProps) {
      var node = _reactDom["default"].findDOMNode(this);

      var properties = mapProperties(props);
      Object.keys(props).forEach(function (name) {
        if (props[name] !== prevProps[name]) {
          if (events[name]) {
            if (prevProps[name]) {
              node.removeEventListener(events[name], prevProps[name]);
            }

            node.addEventListener(events[name], props[name]);
          } else if (properties[name]) {
            node[name] = props[name];
          }
        }
      });
      onRender && onRender.call(this, node, props);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      var _this = this;

      var node = _reactDom["default"].findDOMNode(this);

      Object.keys(events).forEach(function (name) {
        node.removeEventListener(events[name], _this.props[name]);
      });
      onUnmount && onUnmount.call(this, node, this.props);
    };

    _proto.render = function render() {
      var _this2 = this;

      var props = mapAttributes(this.props); // Pass down native react events (eg. onClick) so that they can be handled
      // by reacts syntethic events system

      Object.keys(this.props).forEach(function (name) {
        if (isNativeEvent(name)) {
          props[name] = _this2.props[name];
        }
      });
      return _react["default"].createElement(getTagName(), props);
    };

    (0, _createClass2["default"])(Comp, null, [{
      key: "displayName",
      get: function get() {
        return getTagName();
      }
    }]);
    return Comp;
  }(_react["default"].Component);

  (0, _defineProperty2["default"])(Comp, "propTypes", (0, _extends2["default"])({}, Object.keys(events).reduce(function (types, name) {
    types[name] = _propTypes["default"].func;
    return types;
  }, {})));
  return Comp;
}

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = _default;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(34);

var _hoistNonReactInstanceFunctions = _interopRequireDefault(__webpack_require__(132));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _default(defaultDelay) {
  if (defaultDelay === void 0) {
    defaultDelay = 250;
  }

  return function (WrappedComponent) {
    var DelayMount = /*#__PURE__*/function (_Component) {
      (0, _inheritsLoose2["default"])(DelayMount, _Component);

      function DelayMount() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
          mount: _this.props.delay <= 0
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (wc) {
          wc && (0, _hoistNonReactInstanceFunctions["default"])((0, _assertThisInitialized2["default"])(_this), wc);
        });
        return _this;
      }

      var _proto = DelayMount.prototype;

      _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;

        if (!this.state.mount) {
          this._handle = setTimeout(function () {
            delete _this2._handle;

            _this2.setState({
              mount: true
            });
          }, this.props.delay);
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this._handle && clearTimeout(this._handle);
      };

      _proto.render = function render() {
        var mount = this.state.mount;

        if (!mount) {
          return null;
        }

        var props = (0, _lodash.omit)(this.props, 'delay');
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, {
          ref: this._ref
        }));
      };

      return DelayMount;
    }(_react.Component);

    (0, _defineProperty2["default"])(DelayMount, "propTypes", {
      delay: _propTypes["default"].number
    });
    (0, _defineProperty2["default"])(DelayMount, "defaultProps", {
      delay: defaultDelay
    });
    DelayMount.WrappedComponent = WrappedComponent;
    return DelayMount;
  };
}

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = _default;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(34);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _default(defaultDelay) {
  if (defaultDelay === void 0) {
    defaultDelay = 0;
  }

  return function (Comp) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      (0, _inheritsLoose2["default"])(DebounceInput, _Component);

      function DebounceInput() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
          value: _this.props.value
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_debouncer", null);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refreshDebouncer", true);
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_notify", function (value) {
          _this.props.onChange && _this.props.onChange(value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
          if (e.keyCode === 13) {
            _this._debouncer && _this._debouncer.flush();
          }

          _this.props.onKeyDown && _this.props.onKeyDown(e);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
          _this._debouncer && _this._debouncer.flush();
          _this.props.onBlur && _this.props.onBlur(e);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (value) {
          _this.setState({
            value: value
          });

          if (_this._refreshDebouncer) {
            var delay = _this.props.delay;
            _this._debouncer && _this._debouncer.cancel();
            _this._debouncer = (0, _lodash.debounce)(_this._notify, delay);
            _this._refreshDebouncer = false;
          }

          _this._debouncer(value);
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClear", function () {
          _this._debouncer && _this._debouncer.flush();
          _this.props.onClear && _this.props.onClear();
        });
        (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (input) {
          _this._input = input;
        });
        return _this;
      }

      var _proto = DebounceInput.prototype;

      _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
        var value = _ref.value,
            delay = _ref.delay;

        if (delay !== this.props.delay) {
          this._refreshDebouncer = true;
        }

        if (value === this.state.value || value !== this.props.value) {
          this._debouncer && this._debouncer.cancel();
          this.setState({
            value: value
          });
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this._debouncer && this._debouncer.cancel();
      };

      _proto.focus = function focus() {
        this._input && this._input.focus && this._input.focus();
      };

      _proto.render = function render() {
        var other = (0, _lodash.omit)(this.props, 'delay');
        var value = this.state.value;
        return /*#__PURE__*/_react["default"].createElement(Comp, (0, _extends2["default"])({}, other, {
          ref: this._ref,
          value: value,
          onBlur: this._onBlur,
          onClear: this._onClear,
          onChange: this._onChange,
          onKeyDown: this._onKeyDown
        }));
      };

      return DebounceInput;
    }(_react.Component), (0, _defineProperty2["default"])(_class, "propTypes", (0, _extends2["default"])({}, Comp.propTypes, {
      delay: _propTypes["default"].number,
      value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
      onKeyDown: _propTypes["default"].func,
      onChange: _propTypes["default"].func,
      onBlur: _propTypes["default"].func,
      onClear: _propTypes["default"].func
    })), (0, _defineProperty2["default"])(_class, "defaultProps", (0, _extends2["default"])({}, Comp.defaultProps, {
      delay: defaultDelay
    })), _temp;
  };
}

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ })

},[[595,0]]]);
});